import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export const httpLoggingInterceptor = () => {
  const interceptor: HttpInterceptorFn = (request, next) => {
    return next(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          console.group('[LoggingInterceptor / HTTP Response]');
          console.log(event);
          console.groupEnd();
        }
      }),
    );
  };

  return interceptor;
};
